import {derived} from 'svelte/store';

import {sortKarts}              from '../../services/sort-karts';
import {results3OptimizedStore} from './results-3-optimized-store';
import {sortKeysStore}          from './sort-keys-store';

const createStore = () => {
  const {subscribe} = derived(
    [results3OptimizedStore, sortKeysStore],
    ([$results3OptimizedStore, $sortKeysStore]) => {
      const karts = sortKarts($results3OptimizedStore.karts, $sortKeysStore);

      return {
        counts: {
          ...$results3OptimizedStore.counts,
          sorted: karts.length
        },
        karts,
        maxScores: $results3OptimizedStore.maxScores
      }
    }
  );

  return {subscribe};
};

export const results4SortedStore = createStore();
